import { api } from "@/api";

export const deleteSportMapping = async (
  sportId: number,
  id: number
): Promise<void> => {
  await api.client.delete(`/sports-new/${sportId}/mappings/${id}`);
};
